import { reactive } from "vue";

interface LoadingState {
  loading: boolean;
}

const _state = reactive<LoadingState>({
  loading: false,
});

interface LoadingService {
  readonly loading: boolean;
  start(): void;
  stop(): void;
}

const loadingService: LoadingService = {
  get loading(): boolean {
    return _state.loading;
  },
  start(): void {
    _state.loading = true;
  },
  stop(): void {
    _state.loading = false;
  },
};

export default loadingService;
